import './LoadingSonar.scss';
import classNames from 'classnames';
import { LoadingCircle } from './LoadingCircle';
import React from 'react';
import { Tooltip } from 'antd';
export const LoadingSonar = ({ className, tooltip }) => {
    const classes = classNames('loading-sonar', className);
    const icon = React.createElement(LoadingCircle, { className: classes });
    if (!tooltip) {
        return icon;
    }
    return (React.createElement(Tooltip, { placement: 'bottom', title: tooltip }, icon));
};
